module.exports = __webpack_public_path__ + "static/media/stereum_logo_circle.0a13d6d8.png";